import { render, staticRenderFns } from "./GlobalXPSettings.vue?vue&type=template&id=757d4532"
import script from "./GlobalXPSettings.vue?vue&type=script&lang=js"
export * from "./GlobalXPSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports